// src/components/common/ReloadPrompt.tsx
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

export const ReloadPrompt = () => {
  const [needRefresh, setNeedRefresh] = useState(false);
  const { translations } = useLanguage();

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Add event listener for new service worker
      window.addEventListener('sw-new-version', () => {
        setNeedRefresh(true);
      });
    }
  }, []);

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <AnimatePresence>
      {needRefresh && (
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          className="fixed bottom-4 left-4 right-4 z-50 flex justify-center"
        >
          <div className="bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-4">
            <div className="text-gray-700">
              {translations?.reloadPrompt?.newVersion || 'A new version is available'}
            </div>
            <button
              onClick={handleReload}
              className="flex items-center gap-2 px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors"
            >
              <RefreshCw size={18} />
              <span>{translations?.reloadPrompt?.reload || 'Reload'}</span>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
